import { getMediaUploadUrl } from '@wix/ambassador-forms-v4-submission/http';
export const uploadFile = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    let {
      formId,
      file
    } = _ref2;
    async function uploadFileToMediaManager(uploadUrl, _file) {
      const params = {
        filename: _file.name
      };
      const headers = {
        'Content-Type': 'application/octet-stream'
      };
      try {
        var _uploadResponse$data$, _uploadResponse$data$2, _uploadResponse$data$3;
        const uploadResponse = await errorHandler.withErrorHandler(() => _httpClient.put(uploadUrl, _file, {
          headers,
          params
        }), {
          errorCodesMap: {}
        });
        const fileDescriptor = {
          id: (_uploadResponse$data$ = uploadResponse.data.file) == null ? void 0 : _uploadResponse$data$.id,
          displayName: (_uploadResponse$data$2 = uploadResponse.data.file) == null ? void 0 : _uploadResponse$data$2.displayName,
          url: (_uploadResponse$data$3 = uploadResponse.data.file) == null ? void 0 : _uploadResponse$data$3.url
        };
        return fileDescriptor;
      } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        throw resolvedError;
      }
    }
    async function uploadFilesToMediaPlatform(uploadUrl, _file) {
      const params = {
        filename: _file.name
      };
      const headers = {
        'Content-Type': 'application/octet-stream'
      };
      try {
        const uploadResponse = await errorHandler.withErrorHandler(() => _httpClient.put(uploadUrl, _file, {
          headers,
          params
        }), {
          errorCodesMap: {}
        });
        const fileDescriptor = {
          id: uploadResponse.data.payload.id,
          displayName: _file.name,
          url: uploadResponse.data.payload.path
        };
        return fileDescriptor;
      } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        throw resolvedError;
      }
    }
    async function getUploadUrl(_file, _formId) {
      try {
        const {
          data
        } = await errorHandler.withErrorHandler(() => _httpClient.request(getMediaUploadUrl({
          // octet-stream is a generic binary file, we fallback to it in case we can't identify the file type
          mimeType: _file.type || 'application/octet-stream',
          formId,
          filename: _file.name
        })), {
          errorCodesMap: {}
        });
        return {
          uploadUrl: data.uploadUrl,
          generatedByMediaPlatform: data.generatedByMediaPlatform
        };
      } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        throw resolvedError;
      }
    }
    const {
      uploadUrl,
      generatedByMediaPlatform
    } = await getUploadUrl(file, formId);
    const descriptorWithFile = generatedByMediaPlatform ? await uploadFilesToMediaPlatform(uploadUrl, file) : await uploadFileToMediaManager(uploadUrl, file);
    return descriptorWithFile;
  };
};
//# sourceMappingURL=upload-file.js.map